import React from 'react';
import {
    Container, Row, Col
} from 'reactstrap';
import MenuNew from '../MenuNew';
import Sidebar from '../Sidebar/MenuLeft';
import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';


import '../../assets/css/icon_report.css';



class Page extends React.Component {

    render() {
        return (
            <div>
                <MenuNew />
                <NavbarDrop />

                <Container id="wallet_slip">
                    <div className="wallet_slip_img_inst">
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ marginTop: 90 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

                            <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                                <h1>RELATÓRIO IDSS</h1>
                            </Col>

                            <Col style={{ marginTop: 60 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
                        </Row>
                    </div>


                </Container>

                <Container style={{ marginTop: -40 }} >
                    <Row style={{ marginRight: 0 }}>
                        <Col style={{ marginTop: 60, marginRight: 35 }} xs="12" sm="12" md="2" lg="2" xl="4">
                            <Sidebar />
                        </Col>
                        <Col style={{ marginTop: 60, margiLeft: 20 }} xs="12" sm="12" md="10" lg="10" xl="7">
                            <p className="text_footer">RESULTADO DO IDSS</p>
                            <div className="line_footer_gradient">{""}</div>

                            <Row>
                                <Col xs="12" sm="12" md="12" lg="12" xl="12" style={{
                                    marginTop: 36, textAlign: 'justify'
                                }}>
                                    <p>
                                        A Agência Nacional de Saúde Suplementar (ANS) divulgou o resultado do Índice de Desempenho da Saúde Suplementar (IDSS), tendo como ano-base 2017, 2018, 2019 e 2020.
                                        O referido índice diz respeito à avaliação de desempenho das operadoras em que é processado anual e retroativamente, considerando um conjunto indicadores subdivididos em quatro dimensões: Garantia de Acesso, Gestão de Processos e Regulação, Qualidade em Atenção à Saúde e Sustentabilidade no Mercado. Veja:
                                   </p>
                                </Col>
                            </Row>
                            <Row style={{ paddingLeft: 8, marginTop: '-46px' }}>
                                <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: 'rgb(128, 154, 224)'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>


                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='https://planodentalcenter.com.br/assets/pdf/IDSS-2022-2021.pdf'>RESULTADO DO IDSS 2022 - ANO BASE 2021 PDF</a></div>
                                </Col>
                                
                            </Row>

                            <Row style={{ paddingLeft: 8, marginTop: '-46px' }}>
                                <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: 'rgb(128, 154, 224)'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>


                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='https://planodentalcenter.com.br/assets/pdf/IDSS-2021-2020.pdf'>RESULTADO DO IDSS 2021 - ANO BASE 2020 PDF</a></div>
                                </Col>
                                
                            </Row>
                            <Row style={{ paddingLeft: 8, marginTop: '-46px' }}>
                                <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: 'rgb(128, 154, 224)'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>


                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='https://planodentalcenter.com.br/assets/pdf/IDSS-2020-2019.pdf'>RESULTADO DO IDSS 2020 - ANO BASE 2019 PDF</a></div>
                                </Col>
                                
                            </Row>
                            <Row style={{ paddingLeft: 8, marginTop: '-46px' }}>
                                <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: 'rgb(128, 154, 224)'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>


                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='https://planodentalcenter.com.br/assets/pdf/IDSS-2019-2018.pdf'>RESULTADO DO IDSS 2019 - ANO BASE 2018 PDF</a></div>
                                </Col>

                            </Row>
                            <Row style={{ paddingLeft: 8, marginTop: '-46px' }}>
                                <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: 'rgb(128, 154, 224)'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>


                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='https://planodentalcenter.com.br/assets/pdf/IDSS-2018-2017.pdf'>RESULTADO DO IDSS 2018 - ANO BASE 2017 PDF</a></div>
                                </Col>

                            </Row>

                            <Row style={{ paddingLeft: 8, marginTop: '-46px' }}>
                                <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: 'rgba(0, 139, 139, 0.67)'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>


                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='https://www.gov.br/ans/pt-br/assuntos/informacoes-e-avaliacoes-de-operadoras/qualificacao-ans'>O QUE É O IDSS? (SITE ANS)</a></div>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </Container>

                <Footer />
            </div>

        );
    }
}
export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/Idss/Page.js
 **/